export default __webpack_public_path__ + "static/media/6.31b78d08.png";